import React from 'react'

import './PointsCircle.scss'

const PointsCircle = ({ value, points }) => {
  return (
    <div className="points-circle">
      <div className="flex-container">
        <span className="value">{value}</span>
        {points && <span className="points">pts</span>}
      </div>
    </div>
  )
}

export default PointsCircle
